module.exports = __webpack_public_path__ + "static/media/homilia-369-small.9d68daa1.jpg";